import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
export var TrendingSVG = function TrendingSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M28 8h-9a2 2 0 000 4h4.32L17 19l-5.5-6.32a2 2 0 00-1.43-.68 1.92 1.92 0 00-1.48.59l-6 6a2 2 0 002.82 2.82l4.49-4.48 5.6 6.39A2 2 0 0017 24a2 2 0 001.49-.66L26 15v4a2 2 0 004 0v-9a2 2 0 00-2-2z"
  }));
};
TrendingSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(TrendingSVG);